(function () {
    'use strict';

    angular
        .module('completeAir')
        .controller('tariffClassCtrl', tariffClassCtrl)
        .controller('tariffClassNewEditCtrl', tariffClassNewEditCtrl)
        .controller('modalTariffClassDeleteCtrl', modalTariffClassDeleteCtrl);

    tariffClassCtrl.$inject = ['fareClasses', 'linkService'];
    tariffClassNewEditCtrl.$inject = ['$stateParams', 'linkService', 'fareClass', 'tariffClassService', 'cabins','edit'];
    modalTariffClassDeleteCtrl.$inject = ['$uibModalInstance', '$stateParams', 'tariffClassService','fareClass'];

    function tariffClassCtrl(fareClasses, linkService) {

        var vm = this;
        vm.linkService = linkService;
        vm.fareClasses = [];
        vm.fareClasses = fareClasses.data._embedded ? fareClasses.data._embedded.fareClasses : [];
    }

    function tariffClassNewEditCtrl($stateParams, linkService, fareClass, tariffClassService, cabins,edit) {
        var vm = this;
        vm.linkService = linkService;
        vm.edit = edit;
        vm.categories = cabins.data._embedded.categories;

        vm.baseRate = {
            "special": false
        };
        if(edit){
            vm.baseRate = {
                "tradeName": fareClass.data.tradeName,
                "iataCode": fareClass.data.iataCode,
                "categoryId": linkService.getLinkId(fareClass.data._embedded.category._links.self.href),
                "special": fareClass.data.special
            };
        }

        vm.saveBaseRate = function (isValid, baseRate) {
            if (isValid) {
                var save = {
                    "name": baseRate.tradeName,
                    "tradeName": baseRate.tradeName,
                    "iataCode": baseRate.iataCode,
                    "categoryId": baseRate.categoryId,
                    "special": baseRate.special
                }

                if(edit){
                    tariffClassService.updateFareClass($stateParams.id, save)
                        .then(function (result) {
                            vm.cancel();
                        });
                }else{
                    tariffClassService.saveFareClass(save)
                        .then(function (result) {
                            vm.cancel();
                        });
                }
            }
        };

        vm.cancel = function () {
            linkService.reloadRoute('fareClasses', null);
        };
    }

    function modalTariffClassDeleteCtrl($uibModalInstance, $stateParams, tariffClassService,fareClass) {
        var vm = this;
        vm.name = fareClass.data.iataCode;

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        }

        vm.deleteFareClassConfirm = function () {
            tariffClassService.deleteFareClass($stateParams.id)
                .then(function () {
                    $uibModalInstance.close(true);
                });
        }
    }

})();
